import React from "react";
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share';
import { FaFacebook, FaTwitter, FaLine, FaLinkedin, FaWhatsapp } from 'react-icons/fa';

// Inline styles for custom styling
const style = {
  root: {
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    borderRadius: 10,
    color: 'white',
    padding: '20px',
    textAlign: 'center',
    maxWidth: '600px',
    margin: 'auto',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
  },
  title: {
    color: 'white',
    fontStyle: 'Bold',
    fontSize: '30px',
    marginBottom: '20px',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '15px',
    marginBottom: '20px',
  },
  iconWrapper: {
    borderRadius: '50%',
    padding: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'transform 0.2s ease',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
  },
  facebook: {
    backgroundColor: '#4267B2', // Facebook Blue
    color: '#fff',
  },
  twitter: {
    backgroundColor: '#1DA1F2', // Twitter Blue
    color: '#fff',
  },
  whatsapp: {
    backgroundColor: '#25D366', // WhatsApp Green
    color: '#fff',
  },
  line: {
    backgroundColor: '#00C300', // LINE Green
    color: '#fff',
  },
  linkedin: {
    backgroundColor: '#0077B5', // LinkedIn Blue
    color: '#fff',
  },
  copyContainer: {
    border: '1px solid #fff',
    background: 'rgba(0, 0, 0, 0.7)',
    padding: '10px',
    borderRadius: '5px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  url: {
    text:"20px",
    color: 'white',
    textDecoration: 'none',
    whiteSpace: 'nowrap', 
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexGrow: 1, 
    marginRight: '10px', 
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  copyButton: {
    background: '#FF8E53',
    color: 'white',
    border: 'none',
    padding: '5px 10px',
    cursor: 'pointer',
    borderRadius: '3px',
    fontWeight: 'bold',
  },
};

const ShareComponent = ({ propertyUrl }) => {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(propertyUrl);
    alert("URL copied to clipboard!");
  };

  return (
    <div style={style.root}>
      <h2 style={style.title}>Share Properties</h2>
      <div style={style.iconContainer}>
        <FacebookShareButton url={propertyUrl} style={{ ...style.iconWrapper, ...style.facebook }}>
          <FaFacebook />
        </FacebookShareButton>
        <TwitterShareButton url={propertyUrl} style={{ ...style.iconWrapper, ...style.twitter }}>
          <FaTwitter />
        </TwitterShareButton>
        <WhatsappShareButton url={propertyUrl} style={{ ...style.iconWrapper, ...style.whatsapp }}>
          <FaWhatsapp />
        </WhatsappShareButton>
        <a
          href={`https://line.me/R/msg/text/?${propertyUrl}`}
          target="_blank"
          rel="noreferrer"
          style={{ ...style.iconWrapper, ...style.line }}
        >
          <FaLine />
        </a>
        <a
          href={`https://www.linkedin.com/shareArticle?url=${propertyUrl}`}
          target="_blank"
          rel="noreferrer"
          style={{ ...style.iconWrapper, ...style.linkedin }}
        >
          <FaLinkedin />
        </a>
      </div>
      <div style={style.copyContainer}>
        <p onClick={copyToClipboard} style={style.url}>{propertyUrl}</p>
        <button style={style.copyButton} onClick={copyToClipboard}>Copy</button>
      </div>
    </div>
  );
};

export default ShareComponent;
